import React, { useEffect, useState } from 'react';
import api from '@/lib/axios';
import { citiesToOffer, cityKeptOrFilled } from '@/lib/plzOrt';

export function usePlzCities(postalCode) {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    const plz = String(postalCode || '').trim();
    if (!/^\d{5}$/.test(plz)) {
      setCities([]);
      return undefined;
    }
    let cancelled = false;
    Promise.resolve(api.get(`/public/registrations/geo/plz/${plz}`))
      .then((response) => {
        if (!cancelled) setCities(response?.data?.cities || []);
      })
      .catch(() => {
        if (!cancelled) setCities([]);
      });
    return () => { cancelled = true; };
  }, [postalCode]);
  return cities;
}

export function PlzOrtBridge({ postalCode, city, onCity, testId = 'plz-ort' }) {
  const cities = usePlzCities(postalCode);
  useEffect(() => {
    const next = cityKeptOrFilled(city, cities);
    if (next !== (city ?? '')) onCity(next);
    // onCity kommt vom Formular und wechselt bei jedem Rendern.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cities, city]);

  const offered = citiesToOffer(city, cities);
  if (!offered.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5 mt-1" data-testid={`${testId}-suggestions`}>
      <span className="text-xs text-slate-500">Orte zur PLZ:</span>
      {offered.map((name) => (
        <button
          key={name}
          type="button"
          onClick={() => onCity(name)}
          className={`text-xs px-2 py-0.5 rounded-full border transition-colors ${
            name === city
              ? 'bg-brand-red border-brand-red text-white'
              : 'bg-white border-slate-300 text-slate-700 hover:border-brand-red/40 hover:text-brand-red'
          }`}
          data-testid={`${testId}-suggestion-${name}`}
        >
          {name}
        </button>
      ))}
    </div>
  );
}
